import packageJson from '../../package.json';
import { readVersion } from '@/api/server/user/read';

const VERSION_CHECK_KEY = 'version-check-last-check-time';
const ONE_DAY_MS = 24 * 60 * 60 * 1000; // 24시간 (밀리초)

/**
 * 버전 문자열을 비교하는 함수
 * @returns 1: v1 > v2, -1: v1 < v2, 0: v1 === v2
 */
export const compareVersions = (v1: string, v2: string): number => {
  const parts1 = v1.split('.').map(Number);
  const parts2 = v2.split('.').map(Number);
  const maxLength = Math.max(parts1.length, parts2.length);

  for (let i = 0; i < maxLength; i++) {
    const num1 = parts1[i] || 0;
    const num2 = parts2[i] || 0;
    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }
  return 0;
};

/**
 * 하루에 한 번만 버전을 체크하는 함수
 * @returns 버전이 일치하지 않으면 true, 일치하거나 체크하지 않았으면 false
 */
export const checkVersionOncePerDay = async (): Promise<boolean> => {
  if (process.env.NODE_ENV !== 'production') {
    return false;
  }

  try {
    // 이미 새로고침했는지 확인 (무한 루프 방지)
    const hasReloaded = sessionStorage.getItem('version-check-reloaded');
    if (hasReloaded === 'true') {
      return false;
    }

    // 마지막 체크 시간 확인
    const lastCheckTime = localStorage.getItem(VERSION_CHECK_KEY);
    const now = Date.now();

    if (lastCheckTime) {
      const timeSinceLastCheck = now - parseInt(lastCheckTime, 10);
      // 24시간이 지나지 않았으면 체크하지 않음
      if (timeSinceLastCheck < ONE_DAY_MS) {
        return false;
      }
    }

    // 버전 체크 실행
    const clientVersion = packageJson.version;
    const serverResponse = await readVersion();
    const serverVersion = serverResponse?.data?.version;

    if (!serverVersion) {
      console.log('Server version not found');
      return false;
    }

    // 마지막 체크 시간 업데이트
    localStorage.setItem(VERSION_CHECK_KEY, now.toString());

    // 서버 버전이 클라이언트 버전보다 클 때만 새로고침
    if (compareVersions(serverVersion, clientVersion) > 0) {
      sessionStorage.setItem('version-check-reloaded', 'true');
      window.location.reload();
      return true;
    }

    return false;
  } catch (error) {
    console.error('버전 체크 중 오류 발생:', error);
    return false;
  }
};
